import { apiDeleteArchiveItem, apiGetArchiveList, openArchiveItem } from "api/archiveApi";
import {
    openAccountingDrawer,
    openFactorDrawer, openInstallmentDrawer,
    openRemittanceDrawer,
    openTransactionDrawer,
    openTransferDrawer
} from "helpers/DrawerActions";
const defaultTableColumns = [
    {
        name: "نام فایل",
        key: "fileName",
        disableSearch: true,
        clickable: (item) => true,
        onClick: (dispatch, item) => openArchiveItem(dispatch,item),
    },
    {
        name: "سند مربوطه",
        key: "typeFa",
        disableSearch: true,
        getValue: (item) => {
            let value = item.typeFa
            let target = item.targetType
            if (target!==null && target!==undefined && item.type === 'person') {
                 value += ' - ' + target.nickName;
            } else if (target!==null && target!==undefined && (item.type === 'bill' || item.type === 'accounting')) {
                 value += ' - ' + target.description;
            } else if (target!==null && target!==undefined){
                value += ' - ' + target.title;
            }

            return value
        },
        clickable: (item) => true,
        onClick: (dispatch, item) => {
            item.id = item.typeId
            if (['accounting', 'factor', 'transaction', 'transfer', 'bill'].includes(item.type)) {
                item.type_id = item.typeId
                if (item.type === "factor") {
                    openFactorDrawer(dispatch, item);
                } else if (item.type === "transaction") {
                    openTransactionDrawer(dispatch, item);
                } else if (item.type === "transfer") {
                    openTransferDrawer(dispatch, item);
                } else if (item.type === "bill") {
                    openRemittanceDrawer(dispatch, item);
                } else if (item.type === "installment") {
                    openInstallmentDrawer(dispatch, item);
                } else if (item.type === 'accounting') {
                    openAccountingDrawer(dispatch, item);
                }
            } else {
                const baseUrl = window.location.origin + "/"

                let url
                if ((item.type === 'person')) {
                    url = baseUrl + "reports/personalAccountCard?personId=" + item.typeId;
                } else if (item.type === 'product') {
                    url = baseUrl + "reports/productsAccountCard?productId=" + item.typeId;
                }
                window.open(url, "_blank");
            }
        },
    },
    {
        name: "تاریخ ثبت",
        key: "date",
        disableSearch: true,
    },
    {
        name: "سایز فایل",
        key: "size",
        disableSearch: true,
    },
];

export const archiveIndexData = [
    {
        key: "archiveAll",
        tableColumns: defaultTableColumns,
        title: "آرشیو اسناد",
        label: "آرشیو اسناد",
        disableDateFilter: true,
        actions: {
            view: {
                label: "مشاهده سند",
                openDrawer: openArchiveItem,
            },
            fetch: apiGetArchiveList,
            delete: apiDeleteArchiveItem,
            notSelectable: true,
        },
    },
];
